/** Resolve a scope only when its SKUs share one shipped CDT0 from collapse4 — the restriction table matches CDT0, not path text. */
import { buildLayout } from "./buildLayout";
import { collapse4 } from "./collapse4";
import type { StudioDraft, StudioItem, StudioRunGeometry } from "./studioTypes";

export interface Cdt0Resolution {
  variantFor: (skuIds: readonly string[]) => string | null;
}

export const cdt0ResolutionOf = (
  items: readonly StudioItem[],
  draft: StudioDraft,
  runs: readonly StudioRunGeometry[],
): Cdt0Resolution => {
  const collapsed = collapse4(items, draft, runs, buildLayout(items, draft, runs));
  const cdt0Of = (skuId: string) => collapsed.contract.itemValues[skuId]?.[0] ?? "";
  const shipped = new Set(
    Object.values(collapsed.contract.itemValues)
      .map((values) => values[0] ?? "")
      .filter((value) => value !== ""),
  );
  return {
    variantFor: (skuIds) => {
      if (skuIds.length === 0) return null;
      const values = new Set(skuIds.map(cdt0Of).filter((value) => value !== ""));
      // Ambiguous or missing CDT0 cannot name a single restriction row.
      if (values.size !== 1) return null;
      const variant = [...values][0];
      return shipped.has(variant) ? variant : null;
    },
  };
};
